type PluralForms = [one: string, few: string, many: string];

/**
 * Returns the correct plural form for Slavic languages (Russian, Ukrainian, Polish, etc.)
 *
 * @example
 * pluralize(1, ['товар', 'товара', 'товаров'])  // 'товар'
 * pluralize(3, ['товар', 'товара', 'товаров'])  // 'товара'
 * pluralize(5, ['товар', 'товара', 'товаров'])  // 'товаров'
 * pluralize(21, ['товар', 'товара', 'товаров']) // 'товар'
 * pluralize(12, ['товар', 'товара', 'товаров']) // 'товаров'
 */
export const pluralize = (count: number, forms: PluralForms): string => {
  const abs = Math.abs(count);
  const lastTwo = abs % 100;
  const lastOne = abs % 10;

  return lastTwo >= 11 && lastTwo <= 14
    ? forms[2]
    : lastOne === 1
      ? forms[0]
      : lastOne >= 2 && lastOne <= 4
        ? forms[1]
        : forms[2];
};
